// theme.ts
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#4caf88", // 優しいグリーン（マッチしやすい）
      contrastText: "#ffffff",
    },
    error: {
      main: "#c62828", // 落ち着いた赤（注意・エラー用）
      contrastText: "#ffffff",
    },
    background: {
      default: "#d0e8dc",
      // default: "linear-gradient(to bottom right, #e0f8e9, #c6f0d5)",
    },
  },
});
